export default __webpack_public_path__ + "static/media/header.b273f656.png";